import React from 'react'
import { MdBarChart } from 'react-icons/md'
import { BarChart, Bar, ResponsiveContainer, XAxis, LabelList } from 'recharts'

export interface DataPoint {
  xAxis: string
  yAxis: number
}

export type BarGraphProps = {
  data?: DataPoint[]
  legendText?: string
  width: number
  height: number
}

export type HistoryGraphProps = {
  data?: DataPoint[]
  valueFormatter?: (label: any) => string | number | null
  maxHeight?: number
}

export const HistoryGraph = ({
  data,
  maxHeight = 404,
  valueFormatter = v => v
}: HistoryGraphProps) => {
  // Empty state when no data
  if (!data || data.length === 0) {
    return (
      <div
        className='mt-2 flex flex-col items-center justify-center text-center'
        style={{ minHeight: 404, maxHeight }}
      >
        <div className='flex flex-col items-center gap-3 max-w-xs'>
          <MdBarChart className='w-12 h-12 text-gray-300' aria-hidden='true' />
          <div className='flex flex-col gap-1'>
            <p className='text-[15px] sm:text-[16px] font-semibold text-gray-700'>
              No funding data yet
            </p>
            <p className='text-[13px] sm:text-[14px] text-gray-500 leading-relaxed'>
              Your funding history will appear here.
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      data-testid='recharts-wrapper'
      className='mt-2 **:outline-none [&_*:focus]:outline-none'
    >
      <ResponsiveContainer
        width='100%'
        height='100%'
        minHeight={404}
        maxHeight={maxHeight}
        style={{ outline: 'none' }}
      >
        <BarChart
          data={data}
          margin={{
            top: 20,
            bottom: 30
          }}
          style={{ outline: 'none' }}
          tabIndex={-1}
        >
          <Bar
            barSize={36}
            dataKey='yAxis'
            fill='#48785D'
            radius={[8, 8, 0, 0]}
          >
            <LabelList
              dataKey='yAxis'
              formatter={value => (value === 0 ? '' : valueFormatter(value))}
              position='top'
              className='text-[13px] md:text-[15px] text-gray-700 font-bold'
            />
          </Bar>
          <XAxis
            dataKey='xAxis'
            className='text-[14px] sm:text-[15px] font-semibold text-gray-700'
            tick={{ fontSize: 14, fill: '#6b7280', fontWeight: 400 }}
            tickLine={false}
            axisLine={{ stroke: '#e5e7eb', strokeWidth: 1 }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
